<h4 class="m-0">
	Account Management
</h4>
<div class="bg-white mt-3 rounded">
	<p-tabView
		[activeIndex]="activeIndex()"
		(activeIndexChange)="activeIndex.set($event)"
		class="p-3">

		<p-tabPanel header="Your Plan" headerStyleClass="p-1" [cache]="true">
			<ng-template pTemplate="content">
				<app-your-plan></app-your-plan>
			</ng-template>
		</p-tabPanel>

        <!-- <p-tabPanel header="Add-Ons" headerStyleClass="p-1" [cache]="true">
            <ng-template pTemplate="content">
                Add-Ons goes here
			</ng-template>
		</p-tabPanel>-->
	</p-tabView>
</div>
